import React from 'react';

import { Title } from '@components/Title';
import { Avatar } from '@components/Avatar';
import { TextBlock } from '@components/TextBlock';
import { SimpleLink } from '@components/SimpleLink';
import { ContactIcon } from '@components/HomeCard/ContactIcon';

import { mainInfo } from '@consts';

import { useThemeGetter } from '@hooks';

import { useAvatarCalculator } from './HomeCard.hooks';

import {
  HomeContainer,
  InfoContainer,
  NameContainer,
  ContentContainer,
  ContactsContainer,
  DescriptionContainer,
} from './HomeCard.styled';

export const HomeCard = () => {
  const dimension = useAvatarCalculator();
  const {
    theme: { ElementShadow, Main, Title: titleColor, Text },
  } = useThemeGetter();

  return (
    <HomeContainer>
      <ContentContainer>
        <Avatar dimension={dimension} shadow={ElementShadow} />
        <InfoContainer>
          <NameContainer>
            <Title
              size={6}
              color={Main}
              text={mainInfo.PORTFOLIO_NAME}
              shadow={ElementShadow}
            />
            <Title
              text={mainInfo.JOB_TITLE}
              font="SignikaLight"
              color={titleColor}
              size={3}
              shadow={ElementShadow}
            />
          </NameContainer>
          <DescriptionContainer>
            <TextBlock
              text={mainInfo.SHORT_DESCRIPTION}
              align="left"
              indent={30}
              color={Text}
              shadow={ElementShadow}
            />
          </DescriptionContainer>
        </InfoContainer>
      </ContentContainer>
      <ContactsContainer>
        {mainInfo.contact.map((one) => (
          <SimpleLink
            key={one.name}
            link={one.link}
            icon={<ContactIcon type={one.icon} />}
          />
        ))}
      </ContactsContainer>
    </HomeContainer>
  );
};
